import ExcelJS from 'exceljs';

export async function ImportSeparatedKeikaku(keikaku, keikaku_ref1 = null, keikaku_ref2 = null, keikaku_ref3 = null)
{
    const result = [];

    let wb = new ExcelJS.Workbook();

    if (keikaku !== null)
    {
        const buffer = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(keikaku.File);
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(keikaku.File);
        });
        
        const keikakuWB = await wb.xlsx.load(buffer);

        // We expect worksheet [0] to be Toy-Hobby
        let worksheet = keikakuWB.getWorksheet(1);

        const toyTeam = {
            name: 'トイホビー',
            year: keikaku.KeikakuYear,
            revision: keikaku.Revision,
            filename: keikaku.Filename,
            date: keikaku.Date,
            months: []
        };

        for (let c = 1; c <= 12; c++)
        {
            const newMonth = {
                month: c,
                sales_figures: GetCellInteger(worksheet.getCell(3, c)),
                provProfit_figures: GetCellInteger(worksheet.getCell(4, c)),
                sales_plastic: GetCellInteger(worksheet.getCell(5, c)),
                provProfit_plastic: GetCellInteger(worksheet.getCell(6, c)),
                sales_xpna: GetCellInteger(worksheet.getCell(7, c)),
                provProfit_xpna: GetCellInteger(worksheet.getCell(8, c)),
            };

            toyTeam.months.push(newMonth);
        }

        result.push(toyTeam);

        // We expect worksheet [1] to be Game-Dev
        worksheet = keikakuWB.getWorksheet(2);

        const gameTeam = {
            name: 'ゲーム開発',
            year: keikaku.KeikakuYear,
            revision: keikaku.Revision,
            filename: keikaku.Filename,
            date: keikaku.Date,
            months: [],
        };

        for (let c = 1; c <= 12; c++)
        {
            const newMonth = {
                month: c,
                sales: GetCellInteger(worksheet.getCell(3, c)),
                provProfit: GetCellInteger(worksheet.getCell(4, c)),
                profit: GetCellInteger(worksheet.getCell(5, c)),
                operatingProfit: GetCellInteger(worksheet.getCell(6, c)),
                netIncome: GetCellInteger(worksheet.getCell(7, c)),
                stock: GetCellInteger(worksheet.getCell(8, c)),
            };

            gameTeam.months.push(newMonth);
        }

        result.push(gameTeam);
    }

    if (keikaku_ref1 !== null)
    {
        const buffer = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(keikaku_ref1.File);
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(keikaku_ref1.File);
        });
        
        const keikakuWB = await wb.xlsx.load(buffer);

        // We expect worksheet [0] to be Toy-Hobby
        let worksheet = keikakuWB.getWorksheet(0);

        const toyTeam = {
            name: 'トイホビー',
            year: keikaku_ref1.KeikakuYear,
            revision: keikaku_ref1.Revision,
            filename: keikaku_ref1.Filename,
            date: keikaku_ref1.Date,
            months: []
        };

        for (let c = 1; c <= 12; c++)
        {
            const newMonth = {
                month: c,
                sales_figures: GetCellInteger(worksheet.getCell(3, c)),
                provProfit_figures: GetCellInteger(worksheet.getCell(4, c)),
                sales_plastic: GetCellInteger(worksheet.getCell(5, c)),
                provProfit_plastic: GetCellInteger(worksheet.getCell(6, c)),
                sales_xpna: GetCellInteger(worksheet.getCell(7, c)),
                provProfit_xpna: GetCellInteger(worksheet.getCell(8, c)),
            };

            toyTeam.months.push(newMonth);
        }

        result.push(toyTeam);

        // We expect worksheet [1] to be Game-Dev
        worksheet = keikakuWB.getWorksheet(1);

        const gameTeam = {
            name: 'ゲーム開発',
            year: keikaku_ref1.KeikakuYear,
            revision: keikaku_ref1.Revision,
            filename: keikaku_ref1.Filename,
            date: keikaku_ref1.Date,
            months: [],
        };

        for (let c = 1; c <= 12; c++)
        {
            const newMonth = {
                month: c,
                sales: GetCellInteger(worksheet.getCell(3, c)),
                provProfit: GetCellInteger(worksheet.getCell(4, c)),
                profit: GetCellInteger(worksheet.getCell(5, c)),
                operatingProfit: GetCellInteger(worksheet.getCell(6, c)),
                netIncome: GetCellInteger(worksheet.getCell(7, c)),
                stock: GetCellInteger(worksheet.getCell(8, c)),
            };

            gameTeam.months.push(newMonth);
        }

        result.push(gameTeam);
    }

    if (keikaku_ref2 !== null)
    {
        const buffer = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(keikaku_ref2.File);
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(keikaku_ref2.File);
        });
        
        const keikakuWB = await wb.xlsx.load(buffer);

        // We expect worksheet [0] to be Toy-Hobby
        let worksheet = keikakuWB.getWorksheet(0);

        const toyTeam = {
            name: 'トイホビー',
            year: keikaku_ref2.KeikakuYear,
            revision: keikaku_ref2.Revision,
            filename: keikaku_ref2.Filename,
            date: keikaku_ref2.Date,
            months: []
        };

        for (let c = 1; c <= 12; c++)
        {
            const newMonth = {
                month: c,
                sales_figures: GetCellInteger(worksheet.getCell(3, c)),
                provProfit_figures: GetCellInteger(worksheet.getCell(4, c)),
                sales_plastic: GetCellInteger(worksheet.getCell(5, c)),
                provProfit_plastic: GetCellInteger(worksheet.getCell(6, c)),
                sales_xpna: GetCellInteger(worksheet.getCell(7, c)),
                provProfit_xpna: GetCellInteger(worksheet.getCell(8, c)),
            };

            toyTeam.months.push(newMonth);
        }

        result.push(toyTeam);

        // We expect worksheet [1] to be Game-Dev
        worksheet = keikakuWB.getWorksheet(1);

        const gameTeam = {
            name: 'ゲーム開発',
            year: keikaku_ref2.KeikakuYear,
            revision: keikaku_ref2.Revision,
            filename: keikaku_ref2.Filename,
            date: keikaku_ref2.Date,
            months: [],
        };

        for (let c = 1; c <= 12; c++)
        {
            const newMonth = {
                month: c,
                sales: GetCellInteger(worksheet.getCell(3, c)),
                provProfit: GetCellInteger(worksheet.getCell(4, c)),
                profit: GetCellInteger(worksheet.getCell(5, c)),
                operatingProfit: GetCellInteger(worksheet.getCell(6, c)),
                netIncome: GetCellInteger(worksheet.getCell(7, c)),
                stock: GetCellInteger(worksheet.getCell(8, c)),
            };

            gameTeam.months.push(newMonth);
        }

        result.push(gameTeam);
    }

    if (keikaku_ref3 !== null)
    {
        const buffer = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(keikaku_ref3.File);
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(keikaku_ref3.File);
        });
        
        const keikakuWB = await wb.xlsx.load(buffer);

        // We expect worksheet [0] to be Toy-Hobby
        let worksheet = keikakuWB.getWorksheet(0);

        const toyTeam = {
            name: 'トイホビー',
            year: keikaku_ref3.KeikakuYear,
            revision: keikaku_ref3.Revision,
            filename: keikaku_ref3.Filename,
            date: keikaku_ref3.Date,
            months: []
        };

        for (let c = 1; c <= 12; c++)
        {
            const newMonth = {
                month: c,
                sales_figures: GetCellInteger(worksheet.getCell(3, c)),
                provProfit_figures: GetCellInteger(worksheet.getCell(4, c)),
                sales_plastic: GetCellInteger(worksheet.getCell(5, c)),
                provProfit_plastic: GetCellInteger(worksheet.getCell(6, c)),
                sales_xpna: GetCellInteger(worksheet.getCell(7, c)),
                provProfit_xpna: GetCellInteger(worksheet.getCell(8, c)),
            };

            toyTeam.months.push(newMonth);
        }

        result.push(toyTeam);

        // We expect worksheet [1] to be Game-Dev
        worksheet = keikakuWB.getWorksheet(1);

        const gameTeam = {
            name: 'ゲーム開発',
            year: keikaku_ref3.KeikakuYear,
            revision: keikaku_ref3.Revision,
            filename: keikaku_ref3.Filename,
            date: keikaku_ref3.Date,
            months: [],
        };

        for (let c = 1; c <= 12; c++)
        {
            const newMonth = {
                month: c,
                sales: GetCellInteger(worksheet.getCell(3, c)),
                provProfit: GetCellInteger(worksheet.getCell(4, c)),
                profit: GetCellInteger(worksheet.getCell(5, c)),
                operatingProfit: GetCellInteger(worksheet.getCell(6, c)),
                netIncome: GetCellInteger(worksheet.getCell(7, c)),
                stock: GetCellInteger(worksheet.getCell(8, c)),
            };

            gameTeam.months.push(newMonth);
        }

        result.push(gameTeam);
    }

    return result;
}

function GetCellInteger(cell)
{
    if (cell.value === null || cell.value === undefined)
    {
        return null;
    }

    return Math.round(cell.formula ? cell.result : parseFloat(cell.value));
}